export const ISRAS = [
  {
    img: '#',
    title: 'nummer 1',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellendus saepe minima dolorum perspiciatis libero accusantium, molestiae rem fuga! Suscipit mollitia cum, explicabo velit, veniam totam eligendi soluta cupiditate aliquid nam dicta quos. Recusandae, cum dolorum!',
    key: 1,
  },
  {
    img: '#',
    title: 'nummer 2',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellendus saepe minima dolorum perspiciatis libero accusantium, molestiae rem fuga! Suscipit mollitia cum, explicabo velit, veniam totam eligendi soluta cupiditate aliquid nam dicta quos. Recusandae, cum dolorum!',
    key: 2,
  },
  {
    img: '#',
    title: 'nummer 3',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellendus saepe minima dolorum perspiciatis libero accusantium, molestiae rem fuga! Suscipit mollitia cum, explicabo velit, veniam totam eligendi soluta cupiditate aliquid nam dicta quos. Recusandae, cum dolorum!',
    key: 3,
  },
];